export function isKranawetterPortal() {
    return typeof window !== 'undefined'
        && window.location.hostname === 'portal.kranawettertransport.com';
}
